import { render } from "./ReturnToElement.vue?vue&type=template&id=73d53064"
import script from "./ReturnToElement.vue?vue&type=script&lang=js"
export * from "./ReturnToElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__